<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogSatisfaction" max-width="700"   transition="dialog-bottom-transition" scrollable
                  >
            <v-card tile>
                <v-toolbar card dark color="primary">

                    <v-toolbar-title>Rapport  Demande DMD-{{demandeDetail.idDemande}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-alert :value="true" outline color="purple" icon="info">
                               Donnez votre avis sur le traitement de la demande
                            </v-alert>

                             <el-form id="formRapport"   :model="formRapport"   class="demo-form-inline" >
                              <v-layout wrap >
                                     <v-flex xs12>
                                
                                         <el-form-item label="Donnez une note sur 10" prop="satisfait" style="width:50%">
                                            <el-select  v-model="formRapport.satisfait" name="satisfait" placeholder="votre note" style="width: 100%">
                                                <el-option v-for="item in listeSatisfaction" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </v-flex>
                                

                                    <v-flex xs12 >
                                         <el-form-item label="Pourquoi cette note" style="width:100%"  >
                                        <el-input
                                            type="textarea"
                                            :rows="6"
                                            placeholder="Donnez votre avis"
                                            v-model="formRapport.rapport">
                                        </el-input>
                                         </el-form-item >
                                    </v-flex>
                              </v-layout>
                              </el-form>
                        </v-flex>

                         <!-- bouton validation -->  
                                    <v-flex xs12 class="text-xs-right"   >
                                        <v-btn icons dark color="green" @click="submitFormRapport()">Enregistrer<v-icon right>add</v-icon></v-btn>
                                    </v-flex>   
                                    <!-- bouton validation -->    

                    </v-layout>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "RapportDepannage",
        props:["show","demandeDetail"],
        data() 
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
     
            loading: false,
            dialogSatisfaction: false,
            formRapport: {},
           
          
             listeSatisfaction: [
                { text: '1', value: 1 },
                { text: '2', value: 2 },
                { text: '3', value: 3 },
                { text: '4', value: 4 },
                { text: '5', value: 5 },
                { text: '6', value: 6 },
                { text: '7', value: 7 },
                { text: '8', value: 8 },
                { text: '9', value: 9 },
                { text: '10', value: 10 }
            ],
 

         }    
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogSatisfaction = newValue
            }
        },

        methods: {
             closeDialog(){
                this.$emit('close')
            },
             
            submitFormRapport()
            {
                this.loading = true
                let url = this.domaine + 'demande_maintenance/avis/demandeur'

                let form = document.getElementById('formRapport')
                let data = new FormData(form)
                data.append("idDemande",this.demandeDetail.idDemande)  
                data.append("remarqueNote",this.formRapport.rapport)
                 data.append("note",this.formRapport.satisfait)
                this.$http.post(url, data).then(response => {
                     this.closeDialog()
                     this.loading = false
                     this.successNotif("L'enregistrement du rapport s'est bien deroule ")
                },(erreurRep) => {
                    this.$message.error("Une erreur est survenue lors de l'enregistrement du rapport")
                })
            },

             successNotif(mess = ""){
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
            },
        },
        mounted(){
            
        }

    }
    </script>


// WEBPACK FOOTER //
// src/components/maintenance/RapportSatisfaction.vue